import i18n from '@/lang/index'
// 导出配置的路由器
export default [{
        path: '/systemManagement',
        component: () =>
            import ('@/layout/index'),
        redirect: 'systemManagement/systemParamManage',
        meta: {
            title: i18n.t('xi-tong-guan-li'),
            icon: 'icon-xitong',
            perms: ['bee:system']
        },
        children: [{
                path: 'systemParamManage',
                component: () =>
                    import ('@/module/maintenanceCenter/page/systemParam/manage.vue'),
                meta: { icon: 'icon-shebei2', title: i18n.t('xi-tong-can-shu'), perms: ['bee:ops:systemParam'] }
            },
            {
                path: 'paymentType',
                component: () =>
                    import ('@/module/systemManagement/page/paymentType/manage.vue'),
                meta: {
                    title: i18n.t('zhi-fu-fang-shi'),
                    icon: 'icon-jifen2',
                    perms: ['bee:system:paymentType']
                }
            },
            {
                path: 'authorityManagement',
                component: () =>
                    import ('@/module/systemManagement/page/authority/manage.vue'),
                meta: {
                    title: i18n.t('quan-xian-guan-li'),
                    icon: 'icon-quanxian3',
                    perms: ['bee:system:user']
                }
            },
            {
                path: 'userPayment',
                component: () =>
                    import ('@/module/systemManagement/page/userPayment.vue'),
                meta: {
                    title: i18n.t('zhi-fu-qu-dao-guan-li'),
                    icon: 'icon-shangjia',
                    perms: ['bee:pay:operatorPayment']
                }
            },
            {
                path: 'systemLogInfoManager',
                component: () =>
                    import ('@/module/systemManagement/page/systemLogInfo/manage.vue'),
                meta: {
                    title: i18n.t('cao-zuo-ri-zhi'),
                    icon: 'icon-caozuo',
                    perms: ['bee:system:systemLogInfo']
                }
            },
            // {
            //   path: 'personalSettings',
            //   component: () => import('@/module/systemManagement/page/personalSettings.vue'),
            //   hidden: true,
            //   meta: {
            //     title: '个人设置',
            //     icon: 'icon-geren'
            //   }
            // }
        ]
    }, {
        path: '/personalCenter',
        component: () =>
            import ('@/layout/index'),
        redirect: 'personalCenter/personalSettings',
        hidden: true, //隐藏
        meta: {
            title: i18n.t('ge-ren-zhong-xin'),
            icon: 'icon-geren'
        },
        children: [{
            path: 'personalSettings',
            name: 'personalSettings',
            component: () =>
                import ('@/module/systemManagement/page/personalSettings.vue'),
            meta: {
                title: i18n.t('ge-ren-she-zhi'),
                icon: 'icon-caozuo'
            }
        }]
    },
    {
        path: '/strategyCenter',
        component: () =>
            import ('@/layout/index'),
        redirect: 'strategyCenter/xxxxx',
        hidden: true,
        meta: {
            title: i18n.t('ce-lve-zhong-xin'),
            icon: 'icon-geren'
        },
        children: [{
                path: 'rule',
                component: () =>
                    import ('@/module/strategyCenter/page/rule/ruleManage.vue'),
                meta: {
                    title: i18n.t('gui-ze'),
                    icon: 'icon-caozuo',
                }
            },

            {
                path: 'ruleSecene',
                name: 'xxxx',
                component: () =>
                    import ('@/module/strategyCenter/page/scene/sceneManage.vue'),
                meta: {
                    title: i18n.t('chang-jing'),
                    icon: 'icon-caozuo'
                }
            },

            {
                path: 'action',
                name: 'xxxx',
                component: () =>
                    import ('@/module/strategyCenter/page/action/actionManage.vue'),
                meta: {
                    title: i18n.t('dong-zuo'),
                    icon: 'icon-caozuo'
                }
            },

            {
                path: 'entity',
                component: () =>
                    import ('@/module/strategyCenter/page/entity/entityManage.vue'),
                meta: {
                    title: i18n.t('shi-ti'),
                    icon: 'icon-caozuo'
                }
            },

            {
                path: 'property',
                component: () =>
                    import ('@/module/strategyCenter/page/property/propertyManage.vue'),
                meta: {
                    title: i18n.t('shu-xing-0'),
                    icon: 'icon-caozuo'
                }
            },

        ]
    }
]


// WEBPACK FOOTER //
// ./src/module/systemManagement/router/index.js